import { CREATE_POST_SUCCESS } from '../actions/create-post';
import { CREATE_CATEGORY_SUCCESS } from '../actions/create-category';
import { UPDATE_CATEGORY_SUCCESS } from '../actions/update-category';
import { DELETE_POST_SUCCESS } from '../actions/delete-post';
import { UPDATE_POST_SUCCESS } from '../actions/update-post';
import { replace } from '../services/router-utils';
import { getCurrentLocation } from '../selectors/location-history-selectors';
import { getCategory } from '../selectors/categories-selectors';
import { getPost } from '../selectors/post-selectors';

const handlePostEditRedirect = (action, store) => {
  const post = action.payload;
  const category = getCategory(store.getState(), post.categoryId);

  store.dispatch(
    replace({
      pathname: `/${category.slug}/${post.slug}`,
      state: { isAnimated: true },
    })
  );
};

const handlePostDeleteRedirect = (action, store) => {
  const state = store.getState();
  const currentLocation = getCurrentLocation(store.getState());
  const post = getPost(state, action.payload);
  const category = getCategory(state, post.categoryId);
  const isPostPage = currentLocation.pathname.indexOf(`/${category.slug}/${post.slug}`) > -1;
  if (isPostPage) {
    store.dispatch(replace(`/${category.slug}`));
  }
};

const redirectMiddleware = store => next => action => {
  switch (action.type) {
    case CREATE_CATEGORY_SUCCESS:
    case UPDATE_CATEGORY_SUCCESS:
      store.dispatch(replace('/'));
      break;
    case CREATE_POST_SUCCESS: {
      handlePostEditRedirect(action, store);
      break;
    }
    case UPDATE_POST_SUCCESS:
      handlePostEditRedirect(action, store);
      break;
    case DELETE_POST_SUCCESS:
      handlePostDeleteRedirect(action, store);
      break;
    default:
      break;
  }
  return next(action);
};

export default redirectMiddleware;



// WEBPACK FOOTER //
// ./app/middleware/redirect-middleware.js